import React, { useState } from "react";
import Empty from "components/Empty";
import Table from "components/table";
import constants from "./../../../../../../constants";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { usePreviousInvoiceEntries } from "repositories/invoice-repository";
import styles from "./../../invoices.module.scss";
import downloadIcon from "assets/images/download-icon.svg";
import { handleError, handleSuccess } from "utils";

function PreviousInvoice({ accountOwnerId, t }) {
  const PAGE_SIZE = constants.pageSize;
  const [pageNumber, setPageNumber] = useState(1);

  const {
    isLoading: previousInvoiceLoading,
    data: previousInvoiceData,
  } = usePreviousInvoiceEntries(accountOwnerId, pageNumber, PAGE_SIZE);

  const downloadPDF = async (row) => {
    try {
      const link = document.createElement("a");
      link.href = row?.pdfUrl;
      link.setAttribute("download", "previousInvoice.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      handleSuccess(t("superAdmin.previousInvoiceDownloadMsg"));
    } catch (error) {
      handleError(error);
    }
  };

  const columns = [
    {
      attrs: { datatitle: t("superAdmin.subscriptionName") },
      text: t("superAdmin.subscriptionName"),
      dataField: "packageName",
      formatter: (cellContent, row) => {
        if (previousInvoiceLoading)
          return <div className="text-placeholder-150 shimmer-animation"></div>;

        let displayText = row?.subsriptionName + " " + t("subscription");
        if (row?.isMerged) {
          displayText = t("superAdmin.multipleSubscription");
        }
        return (
          <div
            style={{ cursor: "pointer" }}
          >
            {displayText}
          </div>
        );
      },
    },
    {
      attrs: { datatitle: t("superAdmin.totalSubscriptionPrice") },
      text: t("superAdmin.totalSubscriptionPrice"),
      dataField: "totalChargeAmountInCents",
      formatter: (cellContent, row) => {
        if (previousInvoiceLoading)
          return <div className="text-placeholder-100 shimmer-animation"></div>;

        return `${t("cad")} ${(row?.total)}`;
      },
    },
    {
      attrs: { datatitle: t("superAdmin.officeName") },
      text: t("superAdmin.officeName"),
      dataField: "officeName",
      formatter: (cellContent, row) => {
        if (previousInvoiceLoading)
          return <div className="text-placeholder-100 shimmer-animation"></div>;

        return ` ${cellContent ? cellContent : "--"}`;
      },
    },
    {
      attrs: { datatitle: t("superAdmin.startDate") },
      text: t("superAdmin.startDate"),
      dataField: "periodStart",
      formatter: (cellContent, row) => {
        if (previousInvoiceLoading)
          return <div className="text-placeholder-100 shimmer-animation"></div>;

        return moment(row?.startDate).format("MMM DD, YYYY");
      },
    },
    {
      attrs: { datatitle: t("superAdmin.expireDate") },
      text: t("superAdmin.expireDate"),
      dataField: "periodEnd",
      formatter: (cellContent, row) => {
        if (previousInvoiceLoading)
          return <div className="text-placeholder-100 shimmer-animation"></div>;

        return moment(row?.endDate).format("MMM DD, YYYY");
      },
    },
    {
      attrs: { datatitle: t("superAdmin.download") },
      text: "",
      dataField: "actions",
      formatter: (cellContent, row) => {
        return (
          <div
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() =>
              downloadPDF(row)
            }
          >
            <img src={downloadIcon} alt="" />
          </div>
        );
      },
    },
  ];

  const totalItems =
    previousInvoiceData?.pagination?.totalItems ?? 0;
  const rows = previousInvoiceLoading
    ? new Array(PAGE_SIZE).fill({})
    : previousInvoiceData?.data || [];

  return (
    <>
      <div className={` ${styles.invoices_nav_tabs_wrapper} common-tabs `}>
        <Table
          columns={columns}
          data={rows}
          keyField="id"
          handlePagination={setPageNumber}
          pageNumber={pageNumber}
          pageSize={PAGE_SIZE}
          totalItems={totalItems}
        />
      </div>

      {!previousInvoiceLoading && totalItems === 0 && (
        <Empty Message={t("superAdmin.noInvoicesYet")} />
      )}
    </>
  );
}

export default withTranslation()(PreviousInvoice);
